export const EXPLORE_BASICS_TOUR_ID = 'explore-basics-tour-spotlight';
export const EXPLORE_BASICS_TOUR_STEP_1_SPOTLIGHT_ID = 'explore-basics-tour-step-1-spotlight';
export const EXPLORE_BASICS_TOUR_STEP_2_SPOTLIGHT_ID = 'explore-basics-tour-step-2-spotlight';
export const EXPLORE_BASICS_TOUR_STEP_3_SPOTLIGHT_ID = 'explore-basics-tour-step-3-spotlight';
